import React from 'react';
import { Icon } from './Icons.styles';

export const CopyIcon = props => (
	<Icon viewBox="0 0 13 15" {...props}>
		<path
			fill="currentColor"
			d="M4.857 6.5v-.857h5.572V6.5H4.857zm0 2.429V8.07h5.572v.858H4.857zm0 2.571v-.857h5.572v.857H4.857z"
		/>
		<path
			fill="currentColor"
			d="M3.981 3.486v10.171h7.18V3.486h-7.18zM3.56 2.214h8.025c.466 0 .845.38.845.848V14.08a.846.846 0 0 1-.845.848H3.559a.846.846 0 0 1-.845-.848V3.061c0-.467.378-.847.845-.847zm6.727-.871H2.683a.846.846 0 0 0-.844.847v10.596h-.423a.846.846 0 0 1-.845-.848V.92c0-.468.379-.848.845-.848h8.025c.467 0 .845.38.845.848v.424z"
		/>
	</Icon>
);



// WEBPACK FOOTER //
// ./src/shared/icons/CopyIcon.js